import { Text } from '@adobe/react-spectrum';
import { Notification } from 'components/basic/notification';

export type AnnotationVariant = 'positive' | 'negative' | 'yellow' | '';

interface AnnotationProps {
  message: string;
  variant: AnnotationVariant;
}

export const Annotation = (props: AnnotationProps) => {
  const { message, variant } = props;

  if (message === '' || variant === '') return null;

  return (
    <Notification variant={variant}>
      <Text UNSAFE_style={{ whiteSpace: 'pre-line' }}>{message}</Text>
    </Notification>
  );
};
